import { Page, Pagination } from '../../../../models/common';
import {
  EventWithUsers,
  AuditFilters,
  DetailedEvent,
  StatementEventWithUsers,
  StatementEventsRequest,
  StatementDetailedEvent,
} from '../../../../models/staff/audit';
import { apiSlice } from '../../api-slice';

const baseUrl = `${process.env.REACT_APP_EVENTS_MANAGER_API_URL}/audit`;
const baseStatementsUrl = `${process.env.REACT_APP_EVENTS_MANAGER_API_URL}/audit/statements`;

export const auditApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllAuditEventsPageable: builder.query<
      Page<EventWithUsers>,
      Pagination & {
        readonly request: AuditFilters;
        readonly orderDirection?: 'ASC' | 'DESC';
      }
    >({
      query: ({ page, size, request, orderDirection }) => ({
        url: `${baseUrl}/all-pageable`,
        method: 'POST',
        body: request,
        params: {
          page,
          size,
          orderDirection,
        },
      }),
    }),
    getDetailedAuditById: builder.query<DetailedEvent, number>({
      query: id => ({
        url: `${baseUrl}/${id}`,
      }),
    }),
    getAllStatements: builder.query<StatementEventWithUsers[], void>({
      query: nothing => ({
        url: `${baseStatementsUrl}/all}`,
        method: 'GET',
      }),
    }),
    getAllStatementsEventsPageable: builder.query<
      Page<StatementEventWithUsers>,
      Pagination & {
        readonly request: StatementEventsRequest;
        readonly orderDirection?: 'ASC' | 'DESC';
      }
    >({
      query: ({ page, size, request, orderDirection }) => ({
        url: `${baseStatementsUrl}/all-pageable`,
        method: 'POST',
        body: request,
        params: {
          page,
          size,
          orderDirection,
        },
      }),
    }),
    getDetailedStatementEventById: builder.query<
      StatementDetailedEvent,
      number
    >({
      query: id => ({
        url: `${baseStatementsUrl}/${id}`,
      }),
    }),
  }),
});
